/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React from "react";
import { useGLTF } from "@react-three/drei";
import model from "../assets/gangcuted.gltf"

export default function Prototype3(props) {
    const { nodes, materials } = useGLTF(model);

    return (
        <group {...props} dispose={null}>
            <group position={[0, -1, 0]}>
                <mesh
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube054.geometry}
                    material={materials.handelblack}
                />
                <mesh
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube054_1.geometry}
                    material={materials["Metal grey"]}
                />
                <mesh
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube054_2.geometry}
                    material={materials.Garbage}
                />
                <mesh
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube054_3.geometry}
                    material={materials.Material}
                />
                <mesh
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube054_4.geometry}
                    material={materials.clima}
                />
            </group>
        </group>
    );
}

useGLTF.preload("/gangcuted.gltf");
